import { inactiveKickApi } from '@/request';
import BaseServer from '@/domain/common/base.server.js';
import useMsgServer from '@/domain/common/msg.server.js';

/**
 * 未参加互动（聊天、点赞）踢出
 */
class InactiveKickServer extends BaseServer {
  constructor(options = {}) {
    super(options);

    this.state = {};

    this.listenMsg()
  }

  listenMsg() {
    // 房间消息
    useMsgServer().$onMsg('ROOM_MSG', rawMsg => {
      let temp = Object.assign({}, rawMsg);

      if (typeof temp.data !== 'object') {
        temp.data = JSON.parse(temp.data);
        temp.context = JSON.parse(temp.context);
      }
      // console.log(temp, '原始消息');
      const { type = '' } = temp.data || {};
      switch (type) {
        // 未互动踢出
        case 'inactive_user_kick':
          this.state.inactiveKickInfo = temp.data;
          this.$emit('inactive_user_kick', temp);
          break;
        default:
          break;
      }
    });

  }

  /**
   * 获取【未互动踢出】规则
   * @param {*} webinar_id 活动id
   * @returns
   */
  getInactiveKickRule(webinar_id) {
    const params = {
      "webinar_id": webinar_id
    }
    return inactiveKickApi.getInactiveKickRule(params);
  }

  /**
   * 设置【未互动踢出】规则
   * @param {*} params
   * webinar_id 活动id
   * kick_conditions 踢出条件
   * time_limit 时间
   * @returns
   */
  setInactiveKickRule(params = {}) {
    return inactiveKickApi.setInactiveKickRule(params);
  }

  /**
   * 取消【未互动踢出】规则
   * @param {*} webinar_id 活动id
   * @returns
   */
  cancelInactiveKickRule(webinar_id) {
    const params = {
      "webinar_id": webinar_id
    }
    return inactiveKickApi.cancelInactiveKickRule(params)
  }
}


export default function useInactiveKickServer() {
  if (!useInactiveKickServer.instance) {
    useInactiveKickServer.instance = new InactiveKickServer();
  }

  return useInactiveKickServer.instance;
}
